<template lang="pug">
  .notice-toast(:class="toastClass")
    template(v-if="toastMessage")
      p(v-for="message in toastMessage.message") {{message}}
    template(v-else-if="$slots.default")
      slot
    .close(@click="hide")
      CloseIcon(size="14" :color="iconColor")
</template>

<script>
  import CloseIcon from '../icon/CloseIcon';
  export default {
    name: "NoticeToast",
    components: {
      CloseIcon,
    },
    data () {
      return {
        isShow: false,
        localValiant: ""
      }
    },
    props: {
      valiant: {
        type: String,
        default: ""
      }
    },
    computed: {
      toastClass() {
        let classes = [`is-${this.localValiant}`];
        if (this.isShow) classes.push('is-show');
        return classes;
      },
      iconColor() {
        switch (this.localValiant) {
          case 'success': return 'black-darkest';
          case 'error': return 'white';
          default: return '';
        }
      },
      toastMessage() {
        return this.$store.getters.toastMessage
      }
    },
    methods: {
      show() {
        this.isShow = true;
        this.showHandler();
        setTimeout(this.hide, 5000);
      },

      hide() {
        this.isShow = false;
        this.hideHandler();
      },
      showHandler(e) {
        this.$emit('show', e)
      },
      hideHandler(e) {
        this.$emit('hide', e)
      },
      getToastMessage() {
        return this.$store.getters.toastMessage
      }
    },
    watch: {
      toastMessage: function (to, from) {
        this.localValiant = to['valiant']
        this.show()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../../assets/stylesheets/--new/styles";
  .notice-toast {
    position: fixed;
    bottom: 0;
    left: 50%;
    width: calc(100% - 30px);
    max-width: 550px;
    padding: 9.5px 41px 9.5px 14px;
    margin-bottom: 42px;
    transition: transform .5s ease, opacity .5s ease;
    transform: translate(-50%, calc(100% + 42px));
    opacity: 0;
    border-radius: 3px;
    box-shadow: 0 2px 4px rgba($black-darkest, 0.25);
    line-height: 150%;
    z-index: 10000;
    @include font-size(xs);

    &.is-show {
      transform: translate(-50%, 0);
      opacity: 1;
    }

    &.is-success {
      background: $success;
      color: $black-darkest;
    }

    &.is-error {
      background: $red-base;
      color: $white;
    }
    > p {
      @include margin-bottom(xxs);
    }

    > .close {
      position: absolute;
      display: inline-block;
      top: 13px;
      right: 13px;
      cursor: pointer;
      width: 13px;
      @include mq-down(md) {
        top: 11.5px;
      }
    }
  }
</style>
